import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region ../icons/dist/react/default/chevron.js
const ChevronIcon = (props, ref) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "none",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 2,
		d: "m11.964 9.014-4.95-4.95m0 9.9 4.95-4.95"
	})
});
const ForwardRef = forwardRef(ChevronIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=chevron.js.map